import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import Statistics from './statistics'
export default class index extends Component {
  render() {
    const { match } = this.props
    return (
      <Switch>
        <Route path={`${match.url}/statistics`} component={Statistics} />
        <Redirect from="*" to={`${match.url}/statistics`} />
      </Switch>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/research/pgd/index.js